import { render, staticRenderFns } from "./NoticePage.vue?vue&type=template&id=a62b2df6&scoped=true"
import script from "./NoticePage.vue?vue&type=script&lang=js"
export * from "./NoticePage.vue?vue&type=script&lang=js"
import style0 from "./NoticePage.vue?vue&type=style&index=0&id=a62b2df6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62b2df6",
  null
  
)

export default component.exports